import { makeStyles } from '@material-ui/styles';

export default makeStyles(theme => ({
  root: {
    width: '100%',
    minWidth: '100%',
  },
  container: {
    borderRadius: theme.spacing(1),
    position: 'relative',
    padding: 0,
  },
  dark: {
    border: 'none',
  },
  text: {
    lineHeight: '24px',
    marginTop: '-10px',
  },
  textFirst: {
    backgroundColor: theme.palette.colors.lightGray,
    padding: 10,
    borderRadius: 10,
  },
}));



// WEBPACK FOOTER //
// ./src/sharedComponents/Chat/components/Messages/components/Message/components/TextMessage/useStyles.js